import axios from 'axios'

const notificacaoStore = {
    namespaced: true,
    state: {
        notificacoes: [],
        height: screen.availHeight - 270,        
    },
    mutations: {
        setNotificacoes(state, notificacoes) { state.notificacoes = notificacoes },
    },
    actions: {
        async getNotificacoes(context) {
            context.commit('setNotificacoes', [])
            await axios.get(`/colaborador/mensagem`).then((res) => {
                if (res.data.success) {
                    context.commit('setNotificacoes', res.data.data)
                }
            })
        }
    },
    getters: {
        getQtdMsgNaoVisualizadas(state) {
            return state.notificacoes.filter((notif) => !notif.visualizada).length
        }
    },

}

export default notificacaoStore